import { Category } from '@/models';
import { ListCategoryItem } from './components/listItem';
import { CheckBoxItem } from '@/components';

export const getKeyQueryString = (query: object) => {
	return Object.keys(query)
		.map((key) =>
			query[key] !== '' || query[key] === '' || query[key] === undefined
				? `${key}=${query[key]}`
				: null,
		)
		?.filter((el) => el)
		.join('&');
};

export const removeEmptyObject = (obj: any) => {
	Object.keys(obj).forEach(
		(k) => (obj[k] === undefined || obj[k] === null || obj[k] === '') && delete obj[k],
	);
	return obj;
};
